<template>
    <card-list>
        <subheader-list-item icon="fa-tasks" title="task"/>
        <container-list-item padded>
            <div class="columns">
                <div class="column is-4">
                    <b-field label="Type" label-position="inside">
                        <b-select expanded v-model="task.type">
                            <option :value="t.value" v-for="t in types" :key="t.value">{{t.label}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input maxlength="300" v-model="task.title"/>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Description" label-position="inside">
                        <b-input type="textarea" v-model="task.description"/>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Status" label-position="inside">
                        <b-select expanded v-model="task.status">
                            <option :value="null"></option>
                            <option :value="s.value" v-for="s in statuses" :key="s.value">{{s.label}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Payment" label-position="inside">
                        <b-select expanded v-model="task.payment">
                            <option :value="null"></option>
                            <option :value="p.value" v-for="p in payments" :key="p.value">{{p.label}}</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Assignment" label-position="inside">
                        <b-select expanded v-model="task.assigned_id">
                            <option :value="null"></option>
                            <option :value="a.id" v-for="a in assignees" :key="a.id">{{a.first_name}} {{a.last_name}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Due" label-position="inside">
                        <b-input type="date" v-model="task.due_on"/>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-switch :true-value="1" :false-value="0" v-model="task.complete">Complete</b-switch>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "../../TIER/components/CardList";
    import SubheaderListItem from "../../TIER/components/SubheaderListItem";
    import ContainerListItem from "../../TIER/components/ContainerListItem";
    import {TYPES, STATUSES, PAYMENTS} from "@/components/task_meta";
    import {mapGetters} from "vuex";

    export default {
        name: 'TaskForm',
        props: {
            task: {
                type: Object,
                required: true
            }
        },
        components: {ContainerListItem, SubheaderListItem, CardList},
        computed: {
            ...mapGetters(['assignees'])
        },
        data: function () {
            return {
                types: TYPES,
                statuses: STATUSES,
                payments: PAYMENTS
            };
        }
    };
</script>
